(() => {
  const pauseOtherVideos = (activeVideo) => {
    document.querySelectorAll('.nh-ugc-card__video').forEach((video) => {
      if (video !== activeVideo && !video.paused) video.pause();
    });
  };

  const prepareSocialVideos = (root = document) => {
    root.querySelectorAll('.nh-ugc-card').forEach((card) => {
      if (card.dataset.nhVideoReady) return;

      const video = card.querySelector('.nh-ugc-card__video');
      const button = card.querySelector('.nh-ugc-card__play');
      if (!video || !button) return;

      card.dataset.nhVideoReady = 'true';

      const syncState = () => {
        const isPlaying = !video.paused && !video.ended;
        card.classList.toggle('is-playing', isPlaying);
        button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        button.setAttribute('aria-label', isPlaying ? 'Pause testimonial video' : 'Play testimonial video');
        const icon = button.querySelector('span');
        if (icon) icon.textContent = isPlaying ? '\u23F8' : '\u25B6';
      };

      const toggleVideo = () => {
        if (video.paused || video.ended) {
          pauseOtherVideos(video);
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      button.addEventListener('click', toggleVideo);
      video.addEventListener('click', toggleVideo);
      video.addEventListener('play', syncState);
      video.addEventListener('pause', syncState);
      video.addEventListener('ended', syncState);
      syncState();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareSocialVideos(), { once: true });
  } else {
    prepareSocialVideos();
  }

  document.addEventListener('shopify:section:load', (event) => prepareSocialVideos(event.target));
})();
